import React from 'react';

const ThemeContext = React.createContext({
  theme: null,
  changeTheme: () => {},
});

export default ThemeContext;
